export default [
  {
    path: '/kampanya',
    name: 'kampanya-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'kampanya.Baslik',
      yetki: { k: [2002602] },
    },
  },
]
